<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
          <a href="javascript:;">
            <img
              *ngIf="!leadData?.image"
              src="assets/MeanderLIVE-icon.png"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            />
            <img
              *ngIf="leadData?.image"
              [src]="imageUrl + leadData?.image"
              alt="user view avatar"
              class="users-avatar-shadow rounded"
              height="64"
              width="64"
            />
          </a>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{
                leadData?.title
              }}</span>
              <!-- <span class="text-muted font-medium-1">
                    <span>@</span>
                    <span class="users-view-username">dean3004</span>
                  </span> -->
            </h4>
            <!-- <span class="mr-1">ID :</span> -->
            <!-- <span class="users-view-id">{{
              leadData?._id.substring(leadData?._id.length - 6)
            }}</span> -->
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <!-- <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          ><i class="ft-mail"></i
        ></a>
        <a
          href="javaScript:void(0);"
          class="btn btn-sm bg-light-secondary mr-2 px-3 py-1"
          >Profile</a
        > -->
        <a
          class="btn btn-sm btn-primary px-3 py-1"
          (click)="edit(leadData)">Edit</a
        >
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-4">
                  <h5 class="mb-2 text-bold-500">
                    <i class="ft-info mr-2"></i> Lead Info
                  </h5>
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Title :</td>
                        <td>{{ leadData?.title }}</td>
                      </tr>
  
                      <tr>
                        <td>Type :</td>
                        <td *ngIf="leadData?.type?.displayname">
                          {{ leadData?.type?.displayname }}
                        </td>
                        <td *ngIf="!leadData?.type?.displayname">Not Available</td>
                      </tr>
                      <tr>
                        <td>Lead Stage :</td>
                        <td *ngIf="leadData?.lead_stage?.displayname">
                          {{ leadData?.lead_stage?.displayname}}
                        </td>
                        <td *ngIf="!leadData?.lead_stage?.displayname">Not Available</td>
                      </tr>
                      <tr>
                        <td>Lead Status :</td>
                        <td *ngIf="leadData?.lead_status?.displayname">{{ leadData?.lead_status?.displayname }}</td>
                        <td *ngIf="!leadData?.lead_status?.displayname">Not Available</td>
                      </tr>
                      <tr>
                        <td>Next Action :</td>
                        <td *ngIf="leadData?.next_action?.displayname">{{ leadData?.next_action?.displayname }}</td>
                        <td *ngIf="!leadData?.next_action?.displayname">Not Available</td>
                      </tr>
                      <tr>
                        <td>Notes :</td>
                        <td *ngIf="leadData?.notes">{{ leadData?.notes }}</td>
                        <td *ngIf="!leadData?.notes">Not Available</td>
                      </tr>
                      <tr>
                        <td>Admin Notes :</td>
                        <td *ngIf="leadData?.admin_notes">{{ leadData?.admin_notes }}</td>
                        <td *ngIf="!leadData?.admin_notes">Not Available</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Card data ends -->
          <!-- Training info -->
          <!-- <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-xl-4">
                    <h5 class="mb-2 text-bold-500">
                      <i class="ft-info mr-2"></i> Training Info
                    </h5>
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                            <td>Browser :</td>
                            <td>{{leadData?.type_id }}</td>
                        </tr>
                        <tr>
                            <td>Device Type :</td>
                            <td>{{platform?.deviceType }}</td>
                        </tr>
                        <tr>
                          <td>Ip Address :</td>
                          <td>{{leadData?.ip }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div> -->
        <!-- end -->
        <!-- platform info -->
        <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-xl-4">
                    <h5 class="mb-2 text-bold-500">
                      <i class="ft-info mr-2"></i> Platform Info
                    </h5>
                    <table class="table table-borderless">
                      <tbody>
                        <!-- <tr>
                            <td>Browser :</td>
                            <td>{{platform?.browser }}</td>
                        </tr> -->
                        <tr>
                            <td>Device Type :</td>
                            <td>{{leadData?.platform }}</td>
                        </tr>
                        <tr>
                          <td>Ip Address :</td>
                          <td *ngIf="leadData?.ip">{{leadData?.ip }}</td>
                          <td *ngIf="!leadData?.ip">Not available</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <!-- end -->
        <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-xl-4">
                    <h5 class="mb-2 text-bold-500">
                      <i class="ft-info mr-2"></i> Contact Info
                    </h5>
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Name :</td>
                          <td>{{ leadData?.contact_id?.name }}</td>
                        </tr>
    
                        <tr>
                          <td>Email :</td>
                          <td>
                            {{ leadData?.contact_id?.email }}
                          </td>
                        </tr>
                        <tr>
                          <td>Phone :</td>
                          <td class="users-view-latest-activity">
                            {{ leadData?.contact_id?.phone}}
                          </td>
                        </tr>
                        <tr>
                          <td>Location :</td>
                          <td *ngIf="leadData?.contact_id?.location">{{ leadData?.contact_id?.location}}</td>
                          <td *ngIf="!leadData?.contact_id?.location">Not Available</td>
                        </tr>
                        <tr>
                          <td>Landmark:</td>
                          <td *ngIf="leadData?.contact_id?.landmark?.address">&nbsp;&nbsp; {{leadData?.contact_id?.landmark?.address}}</td>
                          <td *ngIf="!leadData?.contact_id?.landmark?.address">Not Available</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div _ngcontent-fdm-c126="" class="buy-now">
      <a _ngcontent-fdm-c126="" routerLink="/leads/training-leads"  class="btn btn-danger">Back To Training Leads</a>
    </div>
  </section>
  